export default __webpack_public_path__ + "static/media/orchid-protocol.79169c16.jpg";